import Web3 from "web3";
import { sendTransaction } from "@wagmi/core";
import axios from "axios";
import protobuf from "protobufjs";
import firebaseConfigProto from "../protocol/firebase_config.proto";

import polygonTvkAbi from "../json/abi/polygon/PolygonTvkAbi.json";
import polygonStakeAbi from "../json/abi/polygon/PolygonStakeAbi.json";
import ethTvkAbi from "../json/abi/ethereum/EthTvkAbi.json";
import ethStakeAbi from "../json/abi/ethereum/EthStakeAbi.json";
import { readContract } from "@wagmi/core";

export const handleApprovalTVK = async (
  currentProvider,
  walletAddress,
  balance,
  tvkAbi,
  tvkContractAddress,
  tvkStakeContractAddress
) => {
  const web3 = new Web3(currentProvider);
  const contract = new web3.eth.Contract(tvkAbi, tvkContractAddress);
  let amount = web3.utils.toWei(balance, "ether");
  const data = contract.methods
    .approve(tvkStakeContractAddress, amount)
    .encodeABI();
  try {
    let tx = await sendTransaction({
      account: walletAddress,
      to: tvkContractAddress,
      value: "0",
      data: data,
    });
    return tx.hash;
  } catch (error) {
    throw new Error(error);
  }
};

// export const handleSwapToken = async (
//   currentProvider,
//   walletAddress,
//   balance
// ) => {
//   const web3 = new Web3(currentProvider);
//   const contract = new web3.eth.Contract(swapABI, swapContractAddress);
//   let amount = web3.utils.toWei(balance, "ether");
//   const data = contract.methods.swapToken(amount).encodeABI();
//   try {
//     let tx = await sendTransaction({
//       account: walletAddress,
//       to: swapContractAddress,
//       value: "0",
//       data: data,
//     });
//     return tx.hash;
//   } catch (error) {
//     throw new Error(error.message);
//   }
// };

export const handleStakeTVK = async (
  currentProvider,
  walletAddress,
  balance,
  stakeAbi,
  tvkStakeContractAddress
) => {
  const web3 = new Web3(currentProvider);
  const contract = new web3.eth.Contract(stakeAbi, tvkStakeContractAddress);
  let amount = web3.utils.toWei(balance, "ether");
  const data = contract.methods.stake(amount).encodeABI();
  try {
    let tx = await sendTransaction({
      account: walletAddress,
      to: tvkStakeContractAddress,
      value: "0",
      data: data,
    });
    return tx.hash;
  } catch (error) {
    throw new Error(error);
  }
};
export const handleUnStakeTVK = async (
  currentProvider,
  walletAddress,
  stakeAbi,
  tvkStakeContractAddress
) => {
  const web3 = new Web3(currentProvider);
  const contract = new web3.eth.Contract(stakeAbi, tvkStakeContractAddress);
  const data = contract.methods.selectUnstake().encodeABI();
  try {
    let tx = await sendTransaction({
      account: walletAddress,
      to: tvkStakeContractAddress,
      value: "0",
      data: data,
    });
    return tx.hash;
  } catch (error) {
    throw new Error(error);
  }
};

export const handleUnStakeAndClaimTVK = async (
  currentProvider,
  walletAddress,
  stakeAbi,
  tvkStakeContractAddress
) => {
  const web3 = new Web3(currentProvider);
  const contract = new web3.eth.Contract(stakeAbi, tvkStakeContractAddress);
  const data = contract.methods.unstake().encodeABI();
  try {
    let tx = await sendTransaction({
      account: walletAddress,
      to: tvkStakeContractAddress,
      value: "0",
      data: data,
    });
    return tx.hash;
  } catch (error) {
    throw new Error(error);
  }
};

export const getTruncatedAddress = (str) => {
  if (str && str !== "") {
    return str?.slice(0, 5) + str?.slice(-8).replace(/.(?=...)/g, "*");
  }
  return "";
};

export const getDecimalLength = (value) => {
  if (value.includes(".")) {
    return value.split(".")[1]?.length;
  }
  return 0;
};

export const getConfig = async () => {
  try {
    const root = await protobuf.load(firebaseConfigProto);
    const FirebaseConfig = root.lookupType("FirebaseConfig");

    const response = await axios.get(
      `${process.env.REACT_APP_GETCONFIG_API_URL}/config/getConfig`,
      {
        responseType: "arraybuffer",
      }
    );
    const buffer = new Uint8Array(response.data);

    for (let i = 0; i < buffer.length; i++) {
      buffer[i] = buffer[i] ^ 0xaa; // Use the same value as before
    }

    const decodedConfig = FirebaseConfig.decode(buffer);

    return decodedConfig;
  } catch (error) {
    // console.error("Error fetching Firebase config:", error);
  }
};

export const removeHTTPS = (url) => {
  return url.replace("https://", "");
};

export const getCurrentDatePlusUTC = (date) => {
  date.setUTCDate(date.getUTCDate());
  const year = date.getUTCFullYear().toString().slice(-2); // get last two digits of year
  const month = (date.getUTCMonth() + 1).toString().padStart(2, "0"); // month is 0-indexed
  const day = date.getUTCDate().toString().padStart(2, "0");
  const hours = date.getUTCHours().toString().padStart(2, "0");
  const minutes = date.getUTCMinutes().toString().padStart(2, "0");

  return `${day}-${month}-${year} ${hours}:${minutes} UTC`;
};

export const getUnstakeDate = (unstakeTimeStamp, coolDownPeriod) => {
  const sevenDaysInSeconds = coolDownPeriod;
  const newUTC = Number(unstakeTimeStamp) + sevenDaysInSeconds;

  return newUTC;
};

export const formatUTC = (utc, get) => {
  const date = new Date(get ? utc * 1000 : utc); // Convert to milliseconds for JavaScript Date

  const year = date.getUTCFullYear().toString().slice(-2); // get last two digits of year
  const month = (date.getUTCMonth() + 1).toString().padStart(2, "0"); // month is 0-indexed
  const day = date.getUTCDate().toString().padStart(2, "0");
  const hours = date.getUTCHours().toString().padStart(2, "0");
  const minutes = date.getUTCMinutes().toString().padStart(2, "0");

  return `${day}-${month}-${year} ${hours}:${minutes} UTC`;
};

export const convertSeconds = (seconds) => {
  if (seconds < 3600) {
    // Less than an hour
    const minutes = seconds / 60;
    return minutes % 1 === 0
      ? minutes + " minutes"
      : minutes.toFixed(2) + " minutes";
  } else if (seconds < 86400) {
    // Less than a day but more than an hour
    const hours = seconds / 3600;
    return hours % 1 === 0 ? hours + " hours" : hours.toFixed(2) + " hours";
  } else {
    // More than a day
    const days = seconds / 86400;
    return days % 1 === 0 ? days + " days" : days.toFixed(2) + " days";
  }
};

export const getParseEnvChainIds = () => {
  return JSON.parse(process.env.REACT_APP_ETH_SUPPORTED_CHAINS);
};

export const getChainAbiAddressUrl = (networkSelected) => {
  const envChainId = JSON.parse(process.env.REACT_APP_ETH_SUPPORTED_CHAINS);
  const tvkContractAddress =
    networkSelected === envChainId[0]
      ? process.env.REACT_APP_TVK_POLYGON_CONTRACT_ADDRESS
      : process.env.REACT_APP_TVK_ETHEREUM_CONTRACT_ADDRESS;

  const tvkStakeContractAddress =
    networkSelected === envChainId[0]
      ? process.env.REACT_APP_TVK_POLYGON_STAKE_CONTRACT_ADDRESS
      : process.env.REACT_APP_TVK_ETHEREUM_STAKE_CONTRACT_ADDRESS;

  const tvkAbi = networkSelected === envChainId[0] ? polygonTvkAbi : ethTvkAbi;
  const stakeAbi =
    networkSelected === envChainId[0] ? polygonStakeAbi : ethStakeAbi;

  const transactionUrl =
    networkSelected === envChainId[0]
      ? process.env.REACT_APP_POLYGON_SCAN_URL
      : process.env.REACT_APP_ETHEREUM_SCAN_URL;

  return {
    tvkContractAddress,
    tvkStakeContractAddress,
    tvkAbi,
    stakeAbi,
    transactionUrl,
  };
};

export const getBalanceMethod = async (config, currentProvider) => {
  try {
    let data = await readContract({
      ...config,
    });
    const web3 = new Web3(currentProvider);
    let amount = web3.utils.fromWei(data, "ether");
    return amount;
  } catch (error) {
    // console.log(error);
    throw new Error(error);
  }
};
